import { render, staticRenderFns } from "./CarbonEmssionTrendByYear.vue?vue&type=template&id=1ce17b4f&scoped=true&"
import script from "./CarbonEmssionTrendByYear.vue?vue&type=script&lang=js&"
export * from "./CarbonEmssionTrendByYear.vue?vue&type=script&lang=js&"
import style0 from "./CarbonEmssionTrendByYear.vue?vue&type=style&index=0&id=1ce17b4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce17b4f",
  null
  
)

export default component.exports